
import { 
  Card, 
  CardContent,
  CardFooter
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { TrendingUp, DollarSign, ArrowRight } from "lucide-react";

interface NegotiationOpportunityProps {
  opportunity: {
    id: number;
    supplier: string;
    category: string;
    product: string;
    currentPrice: number;
    marketRate: number;
    percentAbove: number;
    potentialSavings: number;
    volumeHistory: string;
  };
}

export const NegotiationOpportunity = ({ opportunity }: NegotiationOpportunityProps) => {
  return (
    <Card className="overflow-hidden">
      <div className="h-2 bg-amber-500" />
      <CardContent className="p-4">
        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-lg">{opportunity.product}</h3>
            <p className="text-muted-foreground text-sm">{opportunity.supplier}</p>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground">Current Price</p>
              <p className="font-semibold">${opportunity.currentPrice.toFixed(2)}</p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground">Market Rate</p>
              <p className="font-semibold text-green-600">${opportunity.marketRate.toFixed(2)}</p>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <Badge variant="destructive" className="flex items-center">
              <TrendingUp className="h-3 w-3 mr-1" />
              {opportunity.percentAbove}% above market
            </Badge>
            <div className="flex flex-col items-end">
              <span className="text-xs text-muted-foreground">Potential Annual Savings</span>
              <span className="font-semibold text-green-600">${opportunity.potentialSavings.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter className="bg-muted/30 p-3 flex justify-between">
        <span className="text-xs">Volume: {opportunity.volumeHistory}</span>
        <Button variant="outline" size="sm" className="h-8">
          Request Quote <ArrowRight className="h-3 w-3 ml-1" />
        </Button>
      </CardFooter>
    </Card>
  );
};
